import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils"

import { useStockAssortmentEvolutionStatusSkuChartData } from "./@hooks"
import StockAssortmentEvolutionStatusSkuChartToolbar from "./Toolbar"


export default function StockAssortmentDetailsStockEvolutionChart() {

    const { dataEvolution, dataEvolutionKeys, dataEvolutionColor, skuName, retailerName, isLoadingDataEvolution, dateRange, onChange, resetEvolutionData } = useStockAssortmentEvolutionStatusSkuChartData()

	if (isEmpty(dataEvolution) || isLoadingDataEvolution) return <></>

    return <ModalSeeker 
        hideActions 
        id="evolution-status-chart1"
        isOpen={!isEmpty(dataEvolution)} 
        title={`Stock Evolution - ${skuName} - ${retailerName}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id="evolution-status-chart2"></Box>}
            pdfProps={{
                titlePDF:`Stock Evolution - ${skuName} - ${retailerName}`
            }}series={dataEvolutionKeys.map(key => ({
                name: key, 
                yField: key,
                xField: "date",
                connect: true,
                color: dataEvolutionColor[key],
                strokes: {
                    strokeDasharray: [0, 100000]
                },
                bullets: { 
                    hidden: false, 
                    radius: 20
                },
                tooltip: {
                    labelText: "[bold]{name}[/]"
                },
            }))}
            chartProps={{
                legend: { hidden: true },
                numberFormat: `#`,
                dateFormatReceived: 'yyyy-MM-dd',
                showBullets: true,
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    hiddenGrid: true,
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    hiddenLabels: true,
                    hiddenGrid: true
                }
            }}
            cardProps={{ actions: <StockAssortmentEvolutionStatusSkuChartToolbar dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 300 }}
        />
    </ModalSeeker>
}